"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sharedUtils_1 = require("src/utils/sharedUtils");
const useLocalStorage_1 = require("src/hooks/useLocalStorage");
const ElementSelector_1 = require("src/projects/Widget/utils/ElementSelector");
const Abstract_1 = __importDefault(require("./Abstract"));
const AdoptyModal_1 = require("src/projects/Widget/shadowDOM/tours/AdoptyModal");
const AdoptyPopover_1 = require("src/projects/Widget/shadowDOM/tours/AdoptyPopover");
// TODO: При открытом редакторе после клика-редиректа открывать автоматом конструктор на текущем туре для быстрого добавление этапа
class GatewayConstructor extends Abstract_1.default {
    constructor(parent) {
        console.log("[GatewayConstructor.constructor]");
        super(parent);
        this.side = (0, useLocalStorage_1.useLocalStorage)("constructor_side");
        this.settings = {
            iframe: {
                id: "adopty-constructor",
                className: "widget-hide",
                allow: "clipboard-write",
                style: `
				position: fixed;
				height: 100%;
				top: 0;
				border: none;
				z-index: 999999
			`,
                src: `${sharedUtils_1.dev_env_object.WIDGET_BASE_URL}/constructor`,
                attributes: {
                    "data-aw-side": (0, useLocalStorage_1.useLocalStorage)("constructor_side"),
                },
            },
        };
        this.onSelectElement = (data) => {
            console.log("[GatewayConstructor.setElement]");
            this.postMessage({
                type: "select_element",
                data: {
                    element: this.cleanSelector(data.path),
                    type: data.type,
                    on_page: (0, sharedUtils_1.getCurrentPage)(),
                },
            });
        };
        this.onRemoveHotspot = (data) => {
            console.log("[GatewayConstructor.onRemoveHotspot]");
            this.parent.hotspots = this.parent.hotspots.filter((hotspot) => hotspot.id !== data.id);
            const element = this.$(`[data-adopty="${data.id}"]`);
            if (element) {
                element.removeElement();
            }
        };
        this.onUpdateTour = (data) => {
            console.log("[GatewayConstructor.onUpdateTour]");
            const index = this.parent.tours.findIndex(item => item.id == data.id);
            this.parent.tours[index] = data;
        };
        this.onHideTourStep = () => {
            console.log("[GatewayConstructor.onHideTourStep]");
            if (this.shownTourStep)
                this.shownTourStep.removeElement();
        };
        this.onShowTourStep = (data) => {
            console.log(`[GatewayConstructor.onShowTourStep] tour ${data.tour} step ${data.id}`);
            if (this.shownTourStep)
                this.shownTourStep.removeElement();
            // можно сделать редирект на другую страницу
            if (data.type == "tooltip") {
                const target = this.$(data.data.element);
                const elementStatus = this.getElementStatus(data.data.element, data.on_page);
                if (!target || data.on_page !== (0, sharedUtils_1.getCurrentPage)()) {
                    this.sendElementStatus(elementStatus);
                    return;
                }
                else {
                    this.sendElementStatus(elementStatus);
                }
                this.shownTourStep = new AdoptyPopover_1.AdoptyPopover(target, data, { demoMode: true });
            }
            else if (data.type == "modal") {
                this.shownTourStep = new AdoptyModal_1.AdoptyModal(data, { demoMode: true });
            }
            if (this.shownTourStep)
                this.$("body").appendChild(this.shownTourStep);
        };
        const self = this;
        this.current_id = null;
        this.visible = false;
        self.createIframe();
        const BtnHandle = document.createElement(`div`);
        BtnHandle.classList.add("adopty-widget-handle");
        this.handle = BtnHandle;
        self.$("body").appendChild(BtnHandle);
        self.$(".adopty-widget-handle").addEventListener("click", function () {
            self.show();
            this.classList.add("hide");
        });
        this.ElementSelector = new ElementSelector_1.ElementSelector(this.$, this.onSelectElement);
    }
    getElementStatus(element, pageStatus) {
        return this.parent._mutationObserverInstance.getElementStatus(element, pageStatus);
    }
    sendElementStatus(elementStatus) {
        console.log("[GatewayConstructor.sendElementStatus]");
        this.postMessage({
            type: "select_element_status",
            data: {
                status: elementStatus
            },
        });
    }
    onConstructorLoaded() {
        console.log("[GatewayConstructor.onConstructorLoaded]");
        if (this.parent.hotspots) {
            this.sendHotspots(this.parent.hotspots);
        }
        if (this.parent.tours) {
            this.sendTours(this.parent.tours);
        }
        this.setProject(this.parent.widget_key);
        this.setPage((0, sharedUtils_1.getCurrentPage)());
        // TODO: только если нужно было сделаить редирект, т.е были на стадии изменений
        // const active_tour = this.parent.localStorageController.get("adopty-tour")?.value || null;
        // const active_step = this.parent.localStorageController.get("adopty-step")?.value || null;
        // this.show_with_tour(active_tour, active_step);
    }
    onConstructorFullScreen(mode) {
        console.log("[GatewayConstructor.onConstructorFullScreen]", mode);
        if (mode) {
            this.iframe.classList.add("widget-fullscreen");
        }
        else {
            this.iframe.classList.remove("widget-fullscreen");
        }
    }
    onClose() {
        console.log("[GatewayConstructor.onClose]");
        this.hide();
        this.ElementSelector.hide_selection();
    }
    onChangeSide(side) {
        console.log("[GatewayConstructor.onChangeSide]");
        this.side = side;
        this.iframe.setAttribute("data-aw-side", this.side);
        (0, useLocalStorage_1.setLocalStorageItem)("constructor_side", this.side);
    }
    setProject(widget_key) {
        console.log("[GatewayConstructor.setProject]");
        this.postMessage({ type: "set_widget_project", data: widget_key });
    }
    setPage(page) {
        console.log("[GatewayConstructor.setPage]");
        this.postMessage({ type: "set_current_page", data: page });
    }
    sendHotspots(data) {
        console.log("[GatewayConstructor.sendHotspots]");
        this.postMessage({ type: "dispatch_hotspots", data: data });
    }
    sendTours(data) {
        console.log("[GatewayConstructor.sendTours]");
        this.postMessage({ type: "dispatch_tours", data: data });
    }
    onAddHotspot(data) {
        console.log(`[GatewayConstructor.onAddHotspot]`);
        this.parent.hotspots.push(data);
        this.parent._mutationObserverInstance.checkElement(data);
    }
    onUpdateHotspot(data) {
        console.log(`[GatewayConstructor.onUpdateHotspot] ID ${data.id}`);
        if (!data.id)
            return;
        const item = this.parent.hotspots.filter((item) => item.draft.id == data.id)[0];
        item.draft = data;
        this.parent._mutationObserverInstance.updateElement(item);
        const elementStatus = this.getElementStatus(data.element, data.on_page);
        this.sendElementStatus(elementStatus);
    }
    onUpdateHotspots(data) {
        var _a;
        console.log("[GatewayConstructor.onUpdateHotspots]");
        this.parent.hotspots = data;
        (_a = this.parent._mutationObserverInstance) === null || _a === void 0 ? void 0 : _a.checkElements();
    }
    onShowSelection(data) {
        console.log("[GatewayConstructor.onShowSelection]");
        const elementStatus = this.getElementStatus(data.element, data.on_page);
        if (elementStatus == "ok" || elementStatus == "notuniq") {
            this.ElementSelector.show_selection(data);
        }
        this.sendElementStatus(elementStatus);
    }
    onStopSelecting(hide_selection) {
        console.log("[GatewayConstructor.onStopSelecting]");
        this.ElementSelector.stop_selecting(hide_selection);
    }
    onSelectElementMode(data) {
        console.log("[GatewayConstructor.onSelectElementMode]");
        this.current_id = data.id;
        this.ElementSelector.start_selecting(data.item, data.type);
    }
    onTourDemoMode(id) {
        console.log("[GatewayConstructor.onTourDemoMode]");
        this.onClose();
        this.parent.TourController.startTour({ id: id, step: 0, demoMode: true });
    }
    show() {
        console.log("[GatewayConstructor.show]");
        this.iframe.classList.replace("widget-hide", "widget-show");
        this.postMessage({ type: "set_constructor_side", data: this.side });
        this.visible = true;
        this.parent._mutationObserverInstance.clearElements();
        this.parent._mutationObserverInstance.checkElements();
    }
    hide() {
        console.log("[GatewayConstructor.hide]");
        this.iframe.classList.replace("widget-show", "widget-hide");
        this.handle.classList.remove("hide");
        this.visible = false;
        this.parent._mutationObserverInstance.clearElements();
        this.parent._mutationObserverInstance.checkElements();
        this.onConstructorFullScreen(false);
        this.onHideTourStep();
    }
}
exports.default = GatewayConstructor;
